module.exports = __webpack_public_path__ + "img/56a13d2.png";